import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { ClassEntity } from "../../entities/class";

@Injectable()
export class ClassRepo extends Repository<ClassEntity>{
    constructor(private dataSource: DataSource) {
        super(ClassEntity, dataSource.createEntityManager());
    }
    async getAllClasses() {
        const classData = await this.createQueryBuilder('c')
            .select('c.id as id,c.class as class')
        const data = await classData.getRawMany();
        return data;
    }
}